import { Amplify } from 'aws-amplify';
import awsmobile from '@/aws-exports';

/**
 * Điểm configure Amplify duy nhất của ứng dụng. Import file này ở `src/App.js` trước mọi
 * thứ khác; nó chạy ngay khi module được nạp.
 *
 * Amplify v6 nhận trực tiếp object `aws-exports` shape cũ (tự chạy parseAWSExports), nên
 * `src/aws-exports.js` KHÔNG phải đụng tới và 21 environment không phải re-generate.
 */
const amplifyConfig = {
    ...awsmobile,
    aws_cloud_logic_custom: awsmobile.aws_cloud_logic_custom.map(api => {
        if (api.name === 'sdautoApi') {
            return { ...api, endpoint: process.env.REACT_APP_API_GATEWAY_ENDPOINT || api.endpoint };
        }
        return api;
    })
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
